function htmlEncode(text) {
	return { __html: text };
}

export { htmlEncode };
